import templateUrl from './menu-list.html';

export const menuListComponent = {
    bindings: {
        details: '<',
        slugUrl: '@',
		menuName: '@',
		menuId: '@'
    },

    templateUrl,

    controller: class MenuListComponent {
       constructor($state, MenuListService, DashboardService) {
			'ngInject';

			this.$state = $state;
			this.menuListService = MenuListService;
			this.dashboardService = DashboardService;
		}

		$onInit() {
			this.details = this.menuListService.getMenuListDetails(this.details);
			this.activeMenuName = this.dashboardService.getActiveMenuName();
			this.details.pageTitle = `${this.activeMenuName} List`;
		} 
    }
};


// WEBPACK FOOTER //
// ./src/app/components/menu-list/menu-list.component.js